document.addEventListener('DOMContentLoaded', function () {
  /* Auto-tag common repeating elements for scroll-reveal animation (works together with the existing .reveal observer in theme.js). */
  var revealSelectors = [
    '.split-showcase__panel',
    '.usp-bar__item',
    '.quote-banner__inner',
    '.quote-box',
    '.story-timeline__item',
    '.lifestyle-banner__inner',
    '.shop-card',
    '.journal-card',
    '.product-bundle__tier',
    '.product-why-choose__item',
    '.product-perfect-for__tile',
    '.product-how-to-use__step',
    '.product-package__card',
    '.article-image-gallery__item',
    '.product-reviews__card',
    '.contact-info-item',
    '.contact-here-for__item',
    '.newsletter-strip__text',
    '.newsletter-banner__inner',
    '.closing-statement',
    '.cart-recs__card',
    '.product-map__chip'
  ];
  revealSelectors.forEach(function (selector) {
    document.querySelectorAll(selector).forEach(function (el) {
      el.classList.add('reveal');
    });
  });

  /* Sticky mobile buy bar: shows once the real buy button has scrolled out of view. */
  var buyRow = document.querySelector('[data-buy-row]');
  var stickyBar = document.querySelector('[data-sticky-bar]');
  if (buyRow && stickyBar && 'IntersectionObserver' in window) {
    var stickyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var scrolledPast = entry.boundingClientRect.top < 0;
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting && scrolledPast);
      });
    }, { threshold: 0 });
    stickyObserver.observe(buyRow);
  }
});
